(ns frontend.ui.component.lp-portal.text-content.pdf.view
  (:require
   [clojure.string :as string]
   [common.util :as cu]
   [frontend.ui.style.theme.core :as theme]
   [frontend.tenant-customizations :as tenant-customizations]))

(def lifeline-custom-style
  {:defaultStyles {:h1 {:fontSize 14
                        :bold     true
                        :color    (theme/color [:pdf :text :h1])}
                   :h2 {:fontSize 14
                        :bold     true
                        :color    (theme/color [:pdf :text :h2])}
                   :h3 {:fontSize 14
                        :bold     true
                        :color    (theme/color [:pdf :text :h3])}
                   :a  {:color      (theme/color [:pdf :text :a])
                        :bold       true
                        :decoration ""}
                   :ul {:marginBottom 0}
                   :li {:marginBottom 2}
                   :p  {:marginBottom 0
                        :fontSize 7.5}}})

(def resi-v2-custom-style
  {:defaultStyles {:h1 {:fontSize 8
                        :bold     true
                        :color    (theme/color [:pdf :text :h1])}
                   :h2 {:fontSize 8
                        :bold     true
                        :color    (theme/color [:pdf :text :h2])}
                   :h3 {:fontSize 8
                        :bold     true
                        :color    (theme/color [:pdf :text :h3])}
                   :a  {:color      (theme/color [:pdf :text :a])
                        :bold       true
                        :decoration ""}
                   :ul {:marginBottom 0
                        :fontSize 9}
                   :li {:marginBottom 2
                        :fontSize 9}
                   :p  {:marginBottom 0
                        :fontSize 9
                        :alignment "justify"}}})

(defn html->pdfmake-elements
  [html-str props]
  (js/htmlToPdfmake
   (clj->js html-str)
   (clj->js (cond
              (= (theme/get-theme) :theme.lp-portal/lifeline)
              lifeline-custom-style
              (:resi-v2-custom-style? props)
              resi-v2-custom-style
              :else
              {:defaultStyles {:h1 {:fontSize 8
                                    :bold     true
                                    :color    (theme/color [:pdf :text :h1])}
                               :h2 {:fontSize 8
                                    :bold     true
                                    :color    (theme/color [:pdf :text :h2])}
                               :h3 {:fontSize 8
                                    :bold     true
                                    :color    (theme/color [:pdf :text :h3])}
                               :a  {:color      (theme/color [:pdf :text :a])
                                    :bold       true
                                    :decoration ""}
                               :ul {:marginBottom 0}
                               :li {:marginBottom 2}
                               :p  {:marginBottom 0}}}))))

(defn remove-double-whitespaces
  [s]
  (string/replace s #"\s+" " "))

(defn trim-paragraphs
  [paragraphs]
  (cond
    (-> paragraphs first (= "<br>"))
    (-> paragraphs rest trim-paragraphs)

    (-> paragraphs last (= "<br>"))
    (-> paragraphs butlast trim-paragraphs)

    :else
    paragraphs))

(defn normalize-html-for-pdf
  "Normalize TipTap HTML for pdfmake compatibility"
  [html-str]
  (when html-str
    (-> html-str
        ;; Remove <p> tags inside list items
        (string/replace #"<li><p>" "<li>")
        (string/replace #"</p></li>" "</li>")
        ;; Remove empty list items  
        (string/replace #"<li></li>" "")
        ;; Preserve user-inserted empty lines as explicit breaks.
        (string/replace #"(?i)<p[^>]*>\s*(?:&nbsp;|<br[^>]*>)?\s*</p>" "<p><br></p>")
        ;; Strikethrough: <s> → <del>
        (string/replace #"<s>" "<del>")
        (string/replace #"</s>" "</del>")
        ;; Underline: <ins> → <u>
        (string/replace #"<ins>" "<u>")
        (string/replace #"</ins>" "</u>"))))

(defn clean-whitespace
  [html-str]
  (-> html-str
      (str)
      (string/replace #"\n" "")
      (string/replace #"\r" "")
      (string/replace #"\t" "")
      (remove-double-whitespaces)
      (string/replace #">\s<" "><")))

(defn list-html?
  [html-str]
  (boolean (re-find #"(?i)<(ul|ol)\b" (str html-str))))

(defn html->pdfmake-content
  ([html-str]
   (html->pdfmake-content html-str {:paragraph-margin-bottom 0}))
  ([html-str {:keys [paragraph-margin-bottom text-color] :as props}]
   (let [cleaned-html (-> html-str normalize-html-for-pdf clean-whitespace)]
     (if (list-html? cleaned-html)
       (let [content (js->clj (html->pdfmake-elements cleaned-html props) :keywordize-keys true)
             content (if (vector? content) content [content])]
         [{:stack  content
           :color  (or text-color (theme/color [:pdf :text :html]))
           :margin [0 0 0 paragraph-margin-bottom]}])
       (let [paragraphs (->> (string/split cleaned-html "<p>")
                             (mapcat #(string/split % "</p>"))
                             (map (fn [p]
                                    (let [trimmed (string/trim p)]
                                      (when-not (cu/blank-value? trimmed)
                                        (str "<p>" trimmed "</p>")))))
                             (remove nil?)
                             (trim-paragraphs))]
         (->> paragraphs
              (map (fn [p]
                     (let [content (js->clj (html->pdfmake-elements p props) :keywordize-keys true)
                           content (if (vector? content) content [content])
                           only-text? (every? :text content)]
                       {(if only-text? :text :stack) content
                        :color (or text-color (theme/color [:pdf :text :html]))
                        :margin [0 0 0 paragraph-margin-bottom]})))))))))

(defn rich-content
  ([html-str]
   (rich-content html-str {:paragraph-margin-bottom 0}))
  ([html-str {:keys [_paragraph-margin-bottom] :as props}]
   (let [res (html->pdfmake-content html-str props)]
     {:stack (if (vector? res)
               res
               [res])})))

(defn optional-footer
  ([data]
   (optional-footer data
                    (cond
                      (tenant-customizations/capman?)
                      {:margin-top    15
                       :margin-bottom 0
                       :margin-left   0
                       :paragraph-margin-bottom 0}
                      :else
                      {:margin-top    5
                       :margin-bottom 5
                       :margin-left   0
                       :paragraph-margin-bottom 0})))
  ([data {:keys [margin-top margin-bottom margin-left _paragraph-margin-bottom] :as props}]
   (when-let [footer (:rich-content data)]
     (let [rich (rich-content footer props)]
       {:layout :noBorders
        :margin [margin-left margin-top 0 margin-bottom]
        :stack  (if (vector? rich)
                  rich
                  [rich])}))))
